module.exports = {
  login: {
    logo: "logo_login.png",
    title: "Log In",
    email_label: "Email address",
    email_placeholder: "Email",
    password_label: "Password",
    password_placeholder: "Password",
    ad_content: "Running an IT team just got easier",
    ad_bg_image: "login_bg.png",
    ad_bg_size: "100%",
  },
  website: {
    title: "ScaleDesk",
    title_image: "logo_full.png",
  },
  aside: {
    admin: {
      title: "Site Admin",
      overview: "Overview",
      overview_icon: "leaderboard",
      consultant_admin: "Contractors",
      consultant_admin_icon: "group",
      company_admin: "Clients",
      company_admin_icon: "work",
      project_admin: "Projects",
      project_admin_icon: "folder",
      setting_admin: "Site Settings",
      setting_admin_icon: "settings_applications",
      available_techs: "Available Techs",
      active_techs: "Active Techs",
      available_techs_icon: " ",
      active_techs_icon: " ",
      payroll: "Payroll",
      payroll_icon: " ",
      map: "Map View",
      map_icon: " ",
      role_admin: "Role Admin",
      role_admin_icon: "",

    },
    client: {
      title: "Client",
      dashboard: "Overview",
      dashboard_icon: "stacked_bar_chart",
      information: "Information",
      information_icon: "info",
      payment: "Payment",
      payment_icon: "attach_money",
      document: "Document",
      document_icon: "sticky_note_2",
      invoice: "Invoice",
      invoice_icon: "local_atm",
      available_techs: "Available Techs",
      available_techs_icon: "assignment_ind",
      available_projects: "Projects",
      available_projects_icon: "work",
    },
    consultant: {
      title: "Consultant",
      dashboard: "Dashboard",
      dashboard_icon: "home",
      resume: "Resume",
      resume_icon: "ballot",
      payment: "Payment",
      payment_icon: "credit_card",
      document: "Document",
      document_icon: "attach_file",
      review: "Review",
      review_icon: "article",
      available_projects: "Available Projects",
      available_projects_icon: "work",
    },
    global: {
      settings: "Settings",
      settings_icon: "settings",
      logout: "Logout",
      logout_icon: "power_settings_new",
    }
  },
  imageCropper: {
    hint: "Click or drag the file here to upload",
    loading: "Uploading…",
    noSupported: "Browser is not supported, please use IE10+ or other browsers",
    success: "Upload success",
    fail: "Upload failed",
    preview: "Preview",
    btn: {
      off: "Cancel",
      close: "Close",
      back: "Back",
      save: "Save",
    },
    error: {
      onlyImg: "Image only",
      outOfSize: "Image exceeds size limit: ",
      lowestPx: "Image's size is too low. Expected at least: ",
    },
  },
};
